const toggle = (el, cl = 'active') => {
  if (!el) return;
  if (Array.isArray(el)) {
    el.forEach((item) => toggle(item, cl));
  } else {
    el.classList.toggle(cl);
  }
};

const add = (el, cl = 'active') => {
  if (!el) return;
  if (Array.isArray(el)) {
    el.forEach((item) => add(item, cl));
  } else {
    el.classList.add(cl);
  }
};

const remove = (el, cl = 'active') => {
  if (!el) return;
  if (Array.isArray(el)) {
    el.forEach((item) => remove(item, cl));
  } else {
    el.classList.remove(cl);
  }
};

const api = async (url) => await fetch(url).then((data) => data.json());

const has = (el, cl = '.active') => {
  return Boolean(el.closest(cl) && el.closest(cl).matches(cl));
};

export function formatNumberWithSpaces(num) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

export function showTooltip(target, text) {
  document.querySelectorAll('.share-tooltip').forEach((t) => t.remove());

  const tip = document.createElement('div');
  tip.className = 'share-tooltip';
  tip.textContent = text;
  document.body.appendChild(tip);

  const rect = target.getBoundingClientRect();

  tip.style.left = rect.left + rect.width / 2 - tip.offsetWidth / 2 + 'px';
  tip.style.top = rect.top - 35 + window.scrollY + 'px';

  requestAnimationFrame(() => tip.classList.add('show'));

  setTimeout(() => {
    tip.classList.remove('show');
    setTimeout(() => tip.remove(), 250);
  }, 1800);
}

const letters = () => {
  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  let result = '';
  for (let i = 0; i < 8; i++) {
    const index = Math.floor(Math.random() * letters.length);
    result += letters.charAt(index);
  }
  return result;
};

const random = (min, max) => Math.round(Math.random() * (max - min + 1) + min);

const small = (text) => {
  const index = 16;
  return text.length > index ? (text = `${text.substring(0, 8)}...`) : text;
};

function g(element, cont = document, flag) {
  const elements = Array.from(cont.querySelectorAll(element));
  if (!elements.length) return;

  if (elements.length === 1) {
    return flag ? elements : elements[0];
  } else {
    return elements;
  }
}

const max = (arr) => arr.reduce((acc, num) => (acc > num ? acc : num));

const upper = (text) => text[0].toUpperCase() + text.slice(1);

const child = (str) => {
  if (typeof str === 'string') {
    return Array.from(g(str).children);
  } else {
    return Array.from(str.children);
  }
};

const scroll = () => {
  const scrollHeight = document.body.scrollHeight - window.innerHeight;
  const height = window.pageYOffset;
  const progress = Math.round((height / scrollHeight) * 100);
  return progress;
};

const isSize = (num) => window.innerWidth <= num;

const round = (num, del) => Math.round(num / del) * del;

const scale = (num, max) => {
  let flag = false;
  let b = 1;
  if (!flag) {
    b += num;
    if (b >= max) {
      flag = true;
    }
  } else {
    b -= num;
    if (b <= -max) {
      flag = false;
    }
  }
};

const loader = () => {
  const loader = g('.loader');
  remove(loader);
  setTimeout(() => {
    loader.remove();
  }, 500);
};

const getUrl = (url) => {
  const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\v=)([^#\\?]*).*/;
  const match = url.match(regExp);
  if (match && match[2].length === 11) {
    return match[2];
  }
};

function duration(duration) {
  const match = duration.match(/PT(\d+H)?(\d+M)?(\d+S)?/);
  if (!match) return '';
  let hours = '',
    minutes = '',
    seconds = '';
  if (match[1]) {
    hours = match[1].replace('H', '').padStart(2, '0');
  }
  if (match[2]) {
    minutes = match[2].replace('M', '').padStart(2, '0');
  }
  if (match[3]) {
    seconds = match[3].replace('S', '').padStart(2, '0');
  }
  return `${hours ? hours + ':' : ''}${minutes !== '' ? minutes : '00'}:${
    seconds !== '' ? seconds : '00'
  }`;
}

function splitArray(arr) {
  const mid = Math.ceil(arr.length / 2);
  const firstHalf = arr.slice(0, mid);
  const secondHalf = arr.slice(mid);
  return [firstHalf, secondHalf];
}

function extractURL(cssURL) {
  const urlPattern = /url\(["']?([^"']+)["']?\)/;
  const match = cssURL.match(urlPattern);
  return match ? match[1] : '';
}

function screen(breakpoint) {
  if (breakpoint === 'phone') {
    return window.innerWidth >= 560;
  } else if (breakpoint === 'tab-mid') {
    return window.innerWidth >= 768;
  } else if (breakpoint === 'tab-big') {
    return window.innerWidth >= 1040;
  }
}

function getOffset(element) {
  const rect = element.getBoundingClientRect();
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

  return {
    top: rect.top + scrollTop,
    left: rect.left + scrollLeft,
  };
}

export {
  getOffset,
  screen,
  child,
  toggle,
  add,
  remove,
  has,
  random,
  g,
  letters,
  small,
  max,
  upper,
  api,
  scroll,
  round,
  isSize,
  scale,
  loader,
  getUrl,
  duration,
  splitArray,
  extractURL,
};
